module.exports = __webpack_public_path__ + "static/media/Piazza turquoise.1df9acb8.jpg";